import { Code, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CopyButton } from './CopyButton';

export function JsonBlock({ value }: { value: unknown }) {
    const { t } = useTranslation();
    const text = JSON.stringify(value, null, 2);

    return (
        <Group align="flex-start" gap="xs" wrap="nowrap">
            <Code
                block
                style={{ flex: 1, whiteSpace: 'pre-wrap', maxHeight: 320, overflow: 'auto' }}
            >
                {text}
            </Code>
            <CopyButton value={text} label={t('common.copy.json')} />
        </Group>
    );
}
